import { useInfiniteQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
	getNotifications,
	markAllNotificationsRead,
	markNotificationRead,
} from "../api/notification-centre-api";
import { NOTIFICATION_CENTRE_QUERY_KEYS } from "../constants/query-keys";

export const useNotifications = (enabled: boolean) => {
	return useInfiniteQuery({
		queryKey: NOTIFICATION_CENTRE_QUERY_KEYS.list(),
		queryFn: ({ pageParam }) => getNotifications(pageParam as number),
		initialPageParam: 1,
		getNextPageParam: (lastPage) =>
			lastPage.meta.current_page < lastPage.meta.last_page
				? lastPage.meta.current_page + 1
				: undefined,
		enabled,
	});
};

export const useMarkNotificationRead = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (id: number) => markNotificationRead(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: NOTIFICATION_CENTRE_QUERY_KEYS.list() });
			queryClient.invalidateQueries({
				queryKey: NOTIFICATION_CENTRE_QUERY_KEYS.unreadCount(),
			});
		},
	});
};

export const useMarkAllNotificationsRead = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: markAllNotificationsRead,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: NOTIFICATION_CENTRE_QUERY_KEYS.list() });
			queryClient.invalidateQueries({
				queryKey: NOTIFICATION_CENTRE_QUERY_KEYS.unreadCount(),
			});
		},
	});
};
